import React from "react";
import DisksApp from "../component/viewer/DisksApp";
import {LoadingText} from "../component/utils/components";
import {DataGrid} from '@mui/x-data-grid';
import {Typography} from "@mui/material";
import {uuid} from "../utils/utils";

class Disks extends DisksApp {


	render() {
		if (!this.state.disks)
			return <LoadingText/>
		if (this.state.disks.length === 0)
			return <Typography> No disks found </Typography>

		return (
			<>
				<Typography align={"center"} variant={"h3"}>Disks</Typography>
				<DataGrid
					sx={{paddingX: 5}}
					rows={this.state.disks}
					getRowId={() => uuid()}
					columns={Object.keys(this.state.disks[0]).map((key) => {
						return {
							field: key,
							headerName: key,
							flex: 1,
						}
					})}
				/>
			</>
		);

	}
}

export default Disks;
